import { takeLatest, put } from 'redux-saga/effects';

import {
  NEW_PRAGA_DOENCA,
  NEW_PRAGA_DOENCA_SUCCESS,
} from '../actionTypes';

import { pragaDoenca } from '../entity';

function* sagaNewPragaDoenca(action) {
  yield put({
    type: NEW_PRAGA_DOENCA_SUCCESS,
    registro: pragaDoenca.newRegistro,
    isCadastroRapido: action.isCadastroRapido || false
  })
}

export default function* watchNewPragaDoenca() {
  yield takeLatest(NEW_PRAGA_DOENCA, sagaNewPragaDoenca)
}